import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ed62e95"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"display":"flex","flex-direction":"column","align-items":"flex-start"}
}
const _hoisted_2 = { class: "input-column cm-align-center" }
const _hoisted_3 = {
  class: "nei ip",
  style: {"margin-right":"1px"}
}
const _hoisted_4 = { class: "input-column cm-align-center" }
const _hoisted_5 = {
  class: "wai ip",
  style: {"margin-right":"1px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: "top-start",
      trigger: "hover",
      width: 280,
      disabled: !_ctx.sip
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('ipColumn.intranetAbbr')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.sip || '--'), 1)
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.sip.split(',')), (ip) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ip,
            class: "popover-ip el-card gap-x-1"
          }, _toDisplayString(ip), 1))
        }), 128))
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_popover, {
      placement: "top-start",
      trigger: "hover",
      width: 280,
      disabled: !_ctx.cip
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('ipColumn.extranetAbbr')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.cip || '--'), 1)
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.cip.split(',')), (ip) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ip,
            class: "popover-ip el-card"
          }, _toDisplayString(ip), 1))
        }), 128))
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}